export default {
    p: {
        uo: {
            kpi: {
                totalUsers: 'Total Users',
                newUsers7d: 'New in 7 days',
                newUsers30d: 'New in 30 days',
                creatorCount: 'Creators',
                creatorDesc: 'Users who published content units ÷ registered users',
                launcherCount: 'Launchers',
                launcherDesc: 'Users who launched tokens ÷ registered users',
                ratio: 'Ratio',
                dau: 'DAU (Latest Day)',
                dauAvg30d: '30-day Avg {value}',
                wau: 'Latest WAU',
                wauDesc: 'Distinct actives in natural week',
                mau: 'Latest MAU',
                mauDesc: 'Distinct actives in natural month',
                avgOnline: 'Avg. Online Time per User',
                avgOnlineDesc: 'Total duration ÷ DAU',
                avgActive: 'Avg. Gateway Visits per User',
                avgActiveDesc: 'Gateway visits ÷ DAU',
            },
            duration: {
                h: 'h',
                m: 'm',
                s: 's',
            },
            summary: {
                dataAsOf: 'Data as of',
                utcNote: 'UTC business day',
            },
            trend: {
                title: 'Active Trend',
                dau: 'DAU',
                wau: 'WAU',
                mau: 'MAU',
                start: 'Start date',
                end: 'End date',
            },
        },
    },
};
